/** Strapi relations may be a numeric id or a populated object. */
export function relationId(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'object') return value.id || null;
  return value;
}
